import { get } from './object';

const unwrapGraphQlList = (obj, pathToEdges) => get(obj, pathToEdges, []).map(edge => edge.node);

export { unwrapGraphQlList };
